module.exports = __webpack_public_path__ + "img/SEJ_Eventos_hora.fe97f108.svg";